import { useMutation, useQuery } from 'react-query'
import { get, post } from 'framework/api/http'

/* BDL20-3995: pre-filled data for the Fix SSCC XML pop-up */
export const getSsccXmlFixData = async (queryData: any) => {
  const validationId = queryData.queryKey[1] as string
  const res = await get(`/TnW/SsccXml/Validations/${validationId}/FixData`)
  return res.data?.data
}

export const useGetSsccXmlFixData = (validationId?: string | null) => {
  return useQuery(['ssccXmlFixData', validationId], getSsccXmlFixData, {
    enabled: !!validationId,
    refetchOnWindowFocus: false,
    cacheTime: 0,
    retry: false,
  })
}

/* BDL20-3995: Save & Trigger SSCC XML */
export const useRetriggerSsccXml = () => {
  return useMutation(
    ({ validationId, submission }: { validationId: string; submission: any }) =>
      post(`/TnW/SsccXml/Validations/${validationId}/Retrigger`, submission),
  )
}
